import React from 'react';
import { css, styled, Typography } from '@lux/ds';

const BannerWrapper = styled('div')(
  ({ theme }) => css`
    background-color: #ff856c; // FIXME Update color name when DS colors are finished (rufous 71)
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 ${theme.space.s};
    border-radius: 4px;
  `,
);

const StagingBanner: React.FC = () => {
  return (
    <BannerWrapper>
      <Typography variant="bodyTextSmall" color="neutral.secondary.100">
        This is a test environment
      </Typography>
    </BannerWrapper>
  );
};

export default StagingBanner;
